let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2Nsgy")).then(() => parcelRequire('KMFZh'));